import React, { useMemo } from 'react';
import { FavoritesButton } from '../FavoritesButton';
import { Icon } from '../Icon';
import { RecommendationProfile } from '../../../employer/units/vacancy/interfaces';
import { ClickTooltip } from '../ClickTooltip';
import { useIsMobile } from '../../hooks';
import { Gender } from '../../enums';

import './styles.scss';

interface Props extends RecommendationProfile {
    onFavoritesClick: () => void;
}

export const WorkerCard = ({
    age,
    gender,
    image,
    isFavorite,
    location,
    name,
    specialities,
    url,
    onFavoritesClick,
}: Props) => {
    const isMobile = useIsMobile();

    const genderIcon = useMemo(() => {
        switch (gender) {
            case Gender.Male:
                return (
                    <Icon icon='mars-regular' className='worker-card-small__gender worker-card-small__gender--male' />
                );
            case Gender.Female:
                return (
                    <Icon
                        icon='venus-regular'
                        className='worker-card-small__gender worker-card-small__gender--female'
                    />
                );
            default:
                return null;
        }
    }, [gender]);

    const visibleSpecialities = useMemo(() => specialities.slice(0, 2), [specialities]);
    const hiddenSpecialities = useMemo(() => specialities.slice(2), [specialities]);

    return (
        <div className='worker-card-small card-item card-item--small'>
            <div className='card-item__content'>
                <div className='card-item__favorites-button'>
                    <FavoritesButton isFavorite={isFavorite} onClick={onFavoritesClick} />
                </div>

                <div className='worker-card-small__photo-wrap'>
                    {image ? (
                        <img src={image} className='worker-card-small__photo' />
                    ) : (
                        <Icon icon='user-duonote' size='40px' className='worker-card-small__photo-placeholder' />
                    )}
                </div>

                <a href={url} className='worker-card-small__name-wrap'>
                    <span className='worker-card-small__name' title='<?= $worker->latinFirstName ?>'>
                        {name}
                    </span>
                    {genderIcon}
                </a>

                <div className='card-info-item card-item__info-item'>
                    <Icon icon='cake-candles-light' />
                    <span className='card-info-item__text'>{age}</span>
                </div>

                {location && (
                    <div className='card-info-item card-item__info-item'>
                        <Icon icon='location-dot-light' />
                        <span className='card-info-item__text' title={location}>
                            {location}
                        </span>
                    </div>
                )}

                {/* <div className="tooltip-popup">
                <div
                    className="card-info-item card-info-item--with-tooltip card-item__info-item tooltip-popup__activate-button">
                    <i aria-hidden="true" className="icon-file-check-light i-default"></i>
                    <span className="card-info-item__text">
                        <?= Yii::t('employer', 'Смотреть контакты') ?>
                    </span>
                </div>

                <div className="tooltip-popup__overlay"></div>
                <div className="tooltip-popup__popup-container">
                    <div className="tooltip-popup__flex-wrap">
                        <div className="tooltip-popup__popup-content">
                            <div className="card-contact-info">
                                <i aria-hidden="true" className="icon-mobile-screen-light card-contact-info__icon i-default"></i>
                                <div className="card-contact-info__content">
                                    <div className="card-contact-info__value">
                                        <a href="tel:+48000000000">+48 000 000 000</a>
                                        <?= Html::img($this->theme->getUrl('img/messenger_icons/viber-small.svg')) ?>
                                        <?= Html::img($this->theme->getUrl('img/messenger_icons/whatsapp-small.svg')) ?>
                                        <?= Html::img($this->theme->getUrl('img/messenger_icons/telegram-small.svg')) ?>
                                    </div>
                                    <div className="card-contact-info__name">Татьяна</div>
                                </div>
                            </div>
                        </div>
                        <i aria-hidden="true" className="icon-times tooltip-popup__close"></i>
                    </div>
                </div>
            </div> */}

                {!!visibleSpecialities.length && (
                    <div className='speciality-labels speciality-labels__wrap worker-card-small__speciality-labels'>
                        {visibleSpecialities.map((i) => (
                            <div className='speciality-labels__item' key={i.id}>
                                <span className='speciality-labels__item-text' title={i.name}>
                                    {i.name}
                                </span>
                                {i.experienceYears && (
                                    <span className='speciality-labels__item-additional-text'>{i.experienceYears}</span>
                                )}
                            </div>
                        ))}

                        {!!hiddenSpecialities.length && (
                            <ClickTooltip
                                activeButton={
                                    <div className='speciality-labels__item'>
                                        <span>{`+${hiddenSpecialities.length}`}</span>
                                    </div>
                                }
                                align={isMobile ? 'left' : 'center'}
                            >
                                <div className='speciality-labels speciality-labels__wrap worker-card-small__speciality-labels'>
                                    {hiddenSpecialities.map((i) => (
                                        <div className='speciality-labels__item' key={i.id}>
                                            <span className='speciality-labels__item-text' title={i.name}>
                                                {i.name}
                                            </span>
                                            {i.experienceYears && (
                                                <span className='speciality-labels__item-additional-text'>
                                                    {i.experienceYears}
                                                </span>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </ClickTooltip>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};
